// Дает пробелы между большими числами
export const normalPrice = (str: string) => {
  return String(str).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
};
